import 'bootstrap/dist/css/bootstrap.css'
import 'babel-polyfill'
import './core/fontawesome.js'
import Vue from 'vue'
import App from './component/app.vue'
import SocialSharing from 'vue-social-sharing'
Vue.use(SocialSharing)
export default new Vue({
  'el': '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js